// Shared HTTP client for the ZIDA backend API.
export const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:5000/api').replace(/\/$/, '');

export class ApiError extends Error {
  constructor(status, message, errors) {
    super(message);
    this.status = status;
    this.errors = errors;
  }
}

// Shopper login (phone + password). Saved in this browser so the shopper stays logged in.
export const CUSTOMER_AUTH_KEY = 'zida_customer_auth_v1';
export const CUSTOMER_LOGOUT_EVENT = 'zida:customer-logged-out';

export const customerSession = {
  get() {
    try {
      return JSON.parse(localStorage.getItem(CUSTOMER_AUTH_KEY)) || null;
    } catch {
      return null;
    }
  },
  set(session) {
    try {
      localStorage.setItem(CUSTOMER_AUTH_KEY, JSON.stringify(session));
    } catch { /* private mode — stays logged in for this tab only */ }
  },
  clear() {
    try {
      localStorage.removeItem(CUSTOMER_AUTH_KEY);
    } catch { /* ignore */ }
  }
};

export async function apiRequest(path, { method = 'GET', body, params } = {}) {
  let url = `${API_URL}${path}`;
  if (params) {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '' && value !== false) {
        query.append(key, value);
      }
    });
    const qs = query.toString();
    if (qs) url += `?${qs}`;
  }

  let res;
  try {
    res = await fetch(url, {
      method,
      headers: {
        ...(body ? { 'Content-Type': 'application/json' } : {}),
        ...(customerSession.get()?.token ? { Authorization: `Bearer ${customerSession.get().token}` } : {})
      },
      body: body ? JSON.stringify(body) : undefined
    });
  } catch (networkError) {
    throw new ApiError(0, 'Cannot reach the store server. Please check your connection and try again.');
  }

  const text = await res.text();
  const data = text ? JSON.parse(text) : null;
  if (!res.ok) {
    // Login expired (or password changed on another phone) → log out here too
    if (res.status === 401 && path.startsWith('/account/') && customerSession.get()) {
      customerSession.clear();
      window.dispatchEvent(new Event(CUSTOMER_LOGOUT_EVENT));
    }
    throw new ApiError(res.status, data?.message || `Request failed (${res.status})`, data?.errors);
  }
  return data;
}
